<template>
  <div class="content-430">
    <div class="header-wrapper-430">
      <SchoolSearch
        ref="schoolSearchRef"
        :table-type="tableType"
        @on-search="handleSearch"
      ></SchoolSearch>
    </div>
    <TeaAttendTable
      ref="teaAttendTableRef"
      :table-list="tableList"
      :table-loading="tableLoading"
      :cfm-count-num="cfmCountNum"
      :total="pageInfo.total"
      :page-type="`teacher`"
      @on-page-change="onPageChange"
      @on-page-size-change="handleSizeChange"
      @on-export="handleExport"
      @on-records="onRecords"
      @on-cancel="handleCancel"
      @on-reissue="handleReissue"
      @on-delete="onDeleteFun"
    ></TeaAttendTable>

    <!-- 操作记录 组件 -->
    <RecordsList ref="recordsListRef"></RecordsList>

    <ExportModal ref="exportModalRef" @on-submit="onExSubmit"></ExportModal>
    <!-- 补发 组件 -->
    <ReissueModal
      ref="reissueModalRef"
      @on-finish="onReissueFinish"
    ></ReissueModal>
  </div>
</template>

<script>
import SchoolSearch from './assets/components/SchoolSearch.vue';
import TeaAttendTable from './assets/components/TeaAttendTable.vue';
import ExportModal from './assets/components/ExportModal.vue';
import RecordsList from './assets/components/RecordsList.vue';
import ReissueModal from './assets/components/ReissueModal.vue';
import financeCenterApi from '@/request/financeCenter/index.js';
import TeaAttend from './mixins/teaAttend';
import { mapMutations } from 'vuex';

export default {
  name: 'AttendSettlementTeacher',
  components: {
    SchoolSearch,

    TeaAttendTable,
    ExportModal,
    RecordsList,
    ReissueModal
  },
  mixins: [TeaAttend],
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('AttendSettlementTeacher');
    next();
  },
  data() {
    return {
      searchConds: {},
      loading: false,
      tableType: '2',
      reissueModal: false, // 补发
      formInfo: {
        money: '', // 金额
        explain: '' // 说明
      },
      ruleFormInfo: {
        money: [{ required: true, message: '请输入金额', trigger: 'blur' }],
        explain: [{ required: true, message: '请输入说明', trigger: 'blur' }]
      }

    };
  },
  created() { },
  activated() {
    this.getTeachersSignConfirmList();
  },
  mounted() {
    this.$refs.schoolSearchRef.handleSearch();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    // 筛选
    handleSearch(info) {
      this.pageInfo.pageNum = 1;
      this.searchConds = info;
      this.getTeachersSignConfirmList();
    },
    // 列表页码改变
    onPageChange(page) {
      this.pageInfo.pageNum = page;
      this.getTeachersSignConfirmList();
    },
    // 列表页码改变
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getTeachersSignConfirmList();
    },

    handleChange(v, row) {
      switch (v) {
        case 'detail':
          break;
        case 'reissue':
          this.reissueModal = true;
          break;
        case 'cancel':
          break;
      }
    },
    // 流程
    handleTeacherList() {
      this.$refs.OperationModalRef.handleOpen();
    },
    // 导出-弹框
    handleExport() {
      this.$refs.exportModalRef.handleShow();
    },
    // 操作记录
    onRecords() {
      this.$refs.recordsListRef.handleShow();
    },
    // 取消
    handleCancel(itemId) {
      this.setCancelPayroll(itemId);
    },
    onDeleteFun(row) {
      this.$Modal.confirm({
        title: `确认删除${row.name}的教师考勤确认单吗？删除后不可恢复！`,
        onOk: () => {
          financeCenterApi.delSheetItem({
            itemId: row.itemId
          }).then((res) => {
            if (res.status == 200) {
              this.$Message.success('操作成功');
              this.getTeachersSignConfirmList();
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    // 补发
    handleReissue(itemId) {
      this.$refs.reissueModalRef.handleShow(itemId);
    },
    onReissueFinish() {
      this.getTeachersSignConfirmList();
    }
  }

};
</script>

<style lang="scss" scoped>
.content-430 {
  .title-box {
    width: 100%;
    display: inline-block;
    text-align: center;
    margin-bottom: 20px;
    vertical-align: middle;
    h2 {
      display: inline-block;
      font-size: 18px;
      line-height: 24px;
    }
    .button-box {
      float: right;
    }
  }
  .table-top {
    h3 {
      display: inline-block;
    }
  }
}
</style>
